
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from "firebase/analytics";
import { GAConfig } from '../apis/endpoints';

const firebaseConfig = {
  apiKey: "AIzaSyCGQ0tYppWFJkuSxBhOpkH0xVDmX245Vdc",
  authDomain: "project-id.firebaseapp.com",
  databaseURL: "https://project-id.firebaseio.com",
  projectId: "project-id",
  storageBucket: "project-id.appspot.com",
  messagingSenderId: "637908496727",
  appId: "2:637908496727:web:a4284b4c99e329d5",
  measurementId: GAConfig
};
const app = initializeApp(firebaseConfig);

const useGAEventsTracker = (category = 'Event Category') => {
    const analytics = getAnalytics(app);
    const trackEvent = ( action = '') =>{
        logEvent(analytics, category, { action });
    }
    return trackEvent;
};

export default useGAEventsTracker;